import "./App.css";
import About from "./components/About";
import Calculator from "./components/Calculator";
import Forms from "./components/Forms";
import Navbars from "./components/Navbars";
import Alert from "./components/Alert";
import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import Dictionary from "./components/Dictionary";
import Rps from "./components/Rps";
import Counter from "./components/Counter";
function App() {
    const [mode, setMode] = useState("light");
    const [text, setText] = useState("dark");
    const [alert, setAlert] = useState(null);

    const showAlert = (message, type) => {
        setAlert({
            msg: message,
            type: type,
        });
        setTimeout(() => {
            setAlert(null);
        }, 1500);
    };

    const toggleMode = () => {
        if (mode === "light") {
            setMode("dark");
            setText("Enable Light mode");
            showAlert("Dark mode has been enabled", "success");
            document.body.style.backgroundColor = "grey";
        } else {
            setMode("light");
            setText("Enable Dark mode");
            showAlert("Light mode has been enabled", "success");
            document.body.style.backgroundColor = "white";
        }
    };

    return (
        <>
            <Navbars
                title="games"
                mode={mode}
                toggleMode={toggleMode}
                text={text}
            />
            <Alert alert={alert} />
            <Routes>
                <Route path="/forms" element={<Forms mode={mode} />} />

                <Route path="/About" element={<About mode={mode} />} />
                <Route
                    path="/Calculator"
                    element={<Calculator mode={mode} />}
                />
                <Route
                    path="/Dictionary"
                    element={<Dictionary mode={mode} />}
                />
                 <Route
                    path="/Rock Paper Scissor"
                    element={<Rps mode={mode} />}
                />
                 <Route
                    path="/Counter"
                    element={<Counter mode={mode} />}
                />
            </Routes>
           
        </>
    );
}

export default App;
